// extracted by mini-css-extract-plugin
export default {"Wrapper":"InterventionsView_Wrapper__Xt3gT"};